<template>
	<div class="event-speakers page">
		<div class="mb-5" v-if="chipsList.length">
			<FilterChipButton
				:isButtonActive="isButtonActive"
				:chipsList="chipsList"
				:clearFilter="clearFilter"
				@handleChipClick="handleChipClick"
			/>
		</div>

		<div v-if="filterModalIsVisible">
			<FilterModal
				:filterModalIsVisible="filterModalIsVisible"
				:currentModalFilter="currentModalFilter"
				:currentModalLabel="currentModalLabel"
				:selectedChips="selectedChips"
				:filters="filters"
				:dateError="date.error"
				:dateOption="date.option"
				:dateRange="date.selectedRange"
				@closeModal="closeModal"
				@applySelection="applySelection"
				@setItem="setItem"
			/>
		</div>
		<v-skeleton-loader
			style="max-width: 555px"
			v-bind="attrs"
			type="card"
			v-if="this.isLoading"
			class="mt-2"
		>
		</v-skeleton-loader>
		<div v-else>
			<NewsFeedEmpty
				class="mt-2"
				v-if="!eventSpeakersList.length"
				title="No speakers found."
				description="Check back later or use search."
			/>
			<div v-else>
				<EventSpeakerCard
					v-for="speaker in eventSpeakersList"
					:key="speaker.speaker_id"
					:speaker="speaker"
				/>
			</div>

			<div
				class="d-flex my-9 justify-center event-speakers__pagination"
				v-if="!isLoading && eventSpeakersList.length > 0"
			>
				<Pagination
					:page="filters.page"
					:pageCount="+this.eventSpeakersMeta.pageCount"
					v-on:pageChange="onPageChange"
				/>
			</div>
		</div>
	</div>
</template>
<script>
import ButtonBack from '@/components/ButtonBack'
import Pagination from '@/components/Pagination'
import EventSpeakerCard from '@/components/Event/EventSpeakerCard'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import Dwh from '@/mixins/Dwh'
import { mapActions, mapGetters } from 'vuex'
import Filter from '@/mixins/Filter'
import FilterModal from '@/components/Modals/FilterModal.vue'
import FilterChipButton from '@/components/FilterChipButtons.vue'

const DEBOUNCE_TIMEOUT = 500

export default {
	components: {
		FilterModal,
		FilterChipButton,
		ButtonBack,
		Pagination,
		EventSpeakerCard,
		NewsFeedEmpty,
	},
	mixins: [Dwh, Filter],
	data() {
		return {
			attrs: {
				class: 'mb-6',
				elevation: 0,
			},
			timer: 0,
		}
	},
	methods: {
		...mapActions('event', ['getEventSpeakersById', 'clearEventSpeakers']),
		...mapActions('app', ['setSearch', 'clearSearch', 'setPageTitle']),
	},
	watch: {
		$route() {
			this.searchText = ''
			this.clearSearch()
		},
	},
	computed: {
		...mapGetters('event', ['eventSpeakers', 'eventSpeakersMeta', 'isLoading', 'event']),
		eventSpeakersList() {
			return this.eventSpeakers.map((speaker) => {
				if (!speaker || !Array.isArray(speaker.speakerView)) return null
				const block = speaker.speakerView.find((b) => b.block_name === 'speakerInfo')
				return block ? block.block_data : null
			})
		},
	},
	created() {
		this.getEventSpeakersById(this.requestQuery)
		this.sendTrigger({
			category: 'Content',
			action: 'view_speakers_list_event',
			module: 'Events',
			data: this.$route.params.id,
			content_chapter_id:
				this.event && this.event.chapter_id ? [this.event.chapter_id] : null,
		})
	},
	mounted() {
		this.setPageTitle('Speakers')
	},
	beforeDestroy() {
		this.clearEventSpeakers()
		this.setPageTitle('')
	},
}
</script>
<style lang="scss"></style>
